import { Component, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'student-signup-message',
	templateUrl: './student-signup-message.component.html',
	styleUrls: [
		'./student-signup-message.component.scss'
	]
})
export class StudentSignupMessageComponent {
	@Output() public onBack = new EventEmitter(); // eslint-disable-line @angular-eslint/no-output-on-prefix
}
